import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Layout from "../Utils/Layout";
import { useNavigate } from "react-router-dom";

const AppDevelopment = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="py-4 fs-3  ps-3" data-aos="fade-left">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-info fw-bold ms-5"
        >
          Back
        </button>
      </div>
      <div></div>
      <Helmet>
        <title>App Development Services | Shoyeb</title>
        <meta
          name="description"
          content="Create native and hybrid mobile applications with our professional app development services. Our experienced team specializes in delivering custom solutions for iOS and Android platforms."
        />
        <meta
          name="keywords"
          content="app development services, mobile app development, iOS app development, Android app development"
        />
      </Helmet>
      <Container>
        <Row className="mt-5" data-aos="fade-right">
          <Col>
            <h1 className="text-center">App Development Services</h1>
            <p className="lead text-center">
              Transform your ideas into powerful mobile applications with our
              expert app development solutions.
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={6} data-aos="fade-down">
            <h3>Our Services</h3>
            <ul>
              <li>iOS app development</li>
              <li>Android app development</li>
              <li>Hybrid app development</li>
              <li>UI/UX design</li>
              <li>Quality assurance and testing</li>
            </ul>
          </Col>
          <Col md={6} data-aos="fade-up">
            <h3>Why Choose Us?</h3>
            <p>
              Our dedicated team of app developers specializes in creating
              native and hybrid mobile applications tailored to your business
              requirements. We leverage the latest technologies and industry
              best practices to deliver custom solutions that engage users and
              drive business growth.
            </p>
            <p>
              Whether you need a simple utility app or a complex enterprise
              solution, we have the expertise to bring your vision to life and
              deliver outstanding results.
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col data-aos="fade-left">
            <h3>Recent Projects</h3>
            <p>
              Here are some examples of the mobile app development projects
              we&apos;ve worked on:
            </p>
            <ul>
              <li>E-commerce apps</li>
              <li>Social networking apps</li>
              <li>Health and fitness apps</li>
              <li>Education and learning apps</li>
              <li>Business and productivity apps</li>
            </ul>
          </Col>
        </Row>
        <Row className="mt-5" data-aos="fade-right">
          <Col>
            <h3>Contact Us</h3>
            <p>Ready to turn your app ideas into reality?</p>
            <a href="mailto:shoyebmd424@mail.com" className="btn btn-info">
              Contact Us
            </a>{" "}
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default AppDevelopment;
